/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Standards_Preset_Delete_Confirm_TextInputs */

const en_standards_preset_delete_confirm_text = /** @type {(inputs: Standards_Preset_Delete_Confirm_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete the preset "${i?.name}"? This cannot be undone.`)
};

const fr_standards_preset_delete_confirm_text = /** @type {(inputs: Standards_Preset_Delete_Confirm_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete the preset "${i?.name}"? This cannot be undone.`)
};

const de_standards_preset_delete_confirm_text = /** @type {(inputs: Standards_Preset_Delete_Confirm_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete the preset "${i?.name}"? This cannot be undone.`)
};

const it_standards_preset_delete_confirm_text = /** @type {(inputs: Standards_Preset_Delete_Confirm_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete the preset "${i?.name}"? This cannot be undone.`)
};

const ru_standards_preset_delete_confirm_text = /** @type {(inputs: Standards_Preset_Delete_Confirm_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete the preset "${i?.name}"? This cannot be undone.`)
};

const es_standards_preset_delete_confirm_text = /** @type {(inputs: Standards_Preset_Delete_Confirm_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete the preset "${i?.name}"? This cannot be undone.`)
};

const zh_cn2_standards_preset_delete_confirm_text = /** @type {(inputs: Standards_Preset_Delete_Confirm_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete the preset "${i?.name}"? This cannot be undone.`)
};

const ja_standards_preset_delete_confirm_text = /** @type {(inputs: Standards_Preset_Delete_Confirm_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete the preset "${i?.name}"? This cannot be undone.`)
};

const hi_standards_preset_delete_confirm_text = /** @type {(inputs: Standards_Preset_Delete_Confirm_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete the preset "${i?.name}"? This cannot be undone.`)
};

const pt_pt2_standards_preset_delete_confirm_text = /** @type {(inputs: Standards_Preset_Delete_Confirm_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete the preset "${i?.name}"? This cannot be undone.`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete the preset \"{name}\"? This cannot be undone." |
*
* @param {Standards_Preset_Delete_Confirm_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const standards_preset_delete_confirm_text = /** @type {((inputs: Standards_Preset_Delete_Confirm_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standards_Preset_Delete_Confirm_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_standards_preset_delete_confirm_text(inputs)
	if (locale === "de") return de_standards_preset_delete_confirm_text(inputs)
	if (locale === "it") return it_standards_preset_delete_confirm_text(inputs)
	if (locale === "ru") return ru_standards_preset_delete_confirm_text(inputs)
	if (locale === "es") return es_standards_preset_delete_confirm_text(inputs)
	if (locale === "zh-CN") return zh_cn2_standards_preset_delete_confirm_text(inputs)
	if (locale === "ja") return ja_standards_preset_delete_confirm_text(inputs)
	if (locale === "hi") return hi_standards_preset_delete_confirm_text(inputs)
	if (locale === "pt-PT") return pt_pt2_standards_preset_delete_confirm_text(inputs)
	return en_standards_preset_delete_confirm_text(inputs)
});